export const real100vw = {
    body : document.querySelector('body'),
    resizeEvaluator : document.getElementById('page'),
    hasScrollbar : false,

    init : function($) {
      real100vw.checkForScrollbar();
      if(typeof ResizeObserver != "undefined") {
        new ResizeObserver(entries => {
          for (let entry of entries) {
            var observeHeight = entry.contentRect.height;
            real100vw.checkForScrollbar();
          }
        }).observe(real100vw.resizeEvaluator);
      }
    },

    checkForScrollbar: function() {
      if (window.innerWidth > real100vw.body.clientWidth + 5) {
        if (real100vw.hasScrollbar === false) {
            real100vw.hasScrollbar = true;
            real100vw.body.classList.add('has-scrollbar');
            real100vw.body.setAttribute('style', '--scroll-bar: ' + (window.innerWidth - real100vw.body.clientWidth) + 'px');
        }
      } else {
          real100vw.hasScrollbar = false;
          real100vw.body.classList.remove('has-scrollbar');
      }
    }
};
